import { useMemo } from "react";

import { TextField } from "@mui/material";

export const MAX_BUCKET_NAME_LENGTH = 28;
const MAX_BUCKET_NAME_LENGTH_ERROR_TEXT = `Bucket name must be less than ${MAX_BUCKET_NAME_LENGTH} characters`;
const hasError = (bucketName: string) => bucketName.length > MAX_BUCKET_NAME_LENGTH;

type Props = {
  bucketName: string;
  setBucketName: (name: string) => void;
  setBucketNameHasError: (hasError: boolean) => void;
};

const BucketNameField = ({ bucketName, setBucketName, setBucketNameHasError }: Props) => {
  const bucketNameErrorText = useMemo(() => {
    if (hasError(bucketName)) {
      return MAX_BUCKET_NAME_LENGTH_ERROR_TEXT;
    }

    return undefined;
  }, [bucketName]);

  return (
    <TextField
      name="name"
      helperText={bucketNameErrorText}
      error={Boolean(bucketNameErrorText)}
      label="Invoice bucket name"
      value={bucketName}
      onChange={(event) => {
        setBucketName(event.target.value);
        setBucketNameHasError(hasError(event.target.value));
      }}
      fullWidth
      sx={{ marginTop: 1 }}
      data-cy="bucket-name-input"
    />
  );
};

export default BucketNameField;
